/**
 * Created by kentalito on 2016-05-27.
 */
"user strict"

var TimeBank = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/timebank',

    initialize: function(options){
        if (options){
            this.customerId = options.customerId;
            this.customerProjectId = options.customerProjectId;
        }
    },

    /*url: function(){
        var url = this.urlRoot;
        if (!this.id && this.customerProjectId)
            url = this.urlRoot + '/project/'+this.customerProjectId;
        else if (!this.id && this.customerId)
            url = this.urlRoot + '/customer/'+this.customerId;
        else if (this.id)
            url = this.urlRoot + '/' + this.id;
        else url = this.urlRoot;
        return url;
    }//*/

    fetch: function(){
        var options = {};
        if (!this.id && this.customerId)
            options.url = this.urlRoot + '/customer/' + this.customerId;
        else if (!this.id && this.customerProjectId)
            options.url = this.urlRoot + '/project/' + this.customerProjectId;
        return Backbone.Model.prototype.fetch.call(this, options);

    },
    share: function(fromTime, toTime, emailAddress, message){
        console.log('click share #',this.id);
        this.shareByEmail(fromTime, toTime, emailAddress,message,false,true);

    },
    shareByEmail: function(fromTime, toTime, emailAddress, message, shareInternalInfo, pdf, include) {
        var data = { to: emailAddress, message: message };
        if (shareInternalInfo) data.internal = true;
        if (pdf) data.pdf = true;
        if (typeof include == 'object')
            data.include = include.join(',');
        else if (include)
            data.include = include;
        if (fromTime != null)
            data.fromtime = fromTime;
        if (toTime != null)
            data.totime = toTime;
        var self = this;
        console.log('fromTime',fromTime);
        console.log('toTime',toTime);
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/share/email',
            type: 'POST',
            data: data
        });

    },


})

var TimeBankTransaction = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/timebanktransaction',

    delete: function(){

    }

})